(() => {
  const widgetSelector = '[data-tf-klarna-widget]';

  const parseCents = (value) => {
    const cents = Number.parseInt(value, 10);
    return Number.isFinite(cents) ? cents : 0;
  };

  const formatMoney = (cents, widget) => {
    const currency = widget?.dataset.currency || Shopify?.currency?.active || 'EUR';
    const locale = widget?.dataset.locale || document.documentElement.lang || navigator.language || 'sk';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2).replace('.', ',')} ${currency}`;
    }
  };

  const renderTemplate = (template, amount) => template.replace('[amount]', amount);

  const updateWidget = (widget, priceCents) => {
    if (!widget || !priceCents) return;

    widget.dataset.priceCents = String(priceCents);
    const installmentCents = Math.round(priceCents / 3);
    const installmentAmount = formatMoney(installmentCents, widget);
    const inlineText = widget.querySelector('[data-tf-klarna-inline]');

    if (inlineText && widget.dataset.templateInline) {
      inlineText.textContent = renderTemplate(widget.dataset.templateInline, installmentAmount);
    }
  };

  const initWidgets = (root = document) => {
    root.querySelectorAll(widgetSelector).forEach((widget) => {
      updateWidget(widget, parseCents(widget.dataset.priceCents));
    });
  };

  document.addEventListener('product-info:loaded', (event) => {
    initWidgets(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data?.variant?.price) return;

      document
        .querySelectorAll(`${widgetSelector}[data-section-id="${data.sectionId}"]`)
        .forEach((widget) => updateWidget(widget, data.variant.price));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWidgets());
  } else {
    initWidgets();
  }
})();
